import { Button, ButtonType, TextInput } from '@resurs-internal/styx-react'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import styles from './Mock.module.scss'
import { useIsInternal } from './useIsInternal'
import { UseRealServiceButton } from './UseRealServiceButton'

const proxyPath = process.env.REACT_APP_RETAIL_FINANCE_MOCK_PROXY_PATH

const TERMINAL_STATUSES = ['COMPLETED', 'CANCELLED', 'EXPIRED', 'FAILED']

export const DigitalIdMockAuthentication = () => {
  const { token } = useParams()
  const [govId, setGovId] = useState('')
  const [status, setStatus] = useState(null)
  const [redirectUrl, setRedirectUrl] = useState(null)
  const [initiated, setInitiated] = useState(false)
  const isInternal = useIsInternal()

  useEffect(() => {
    let active = true
    setInitiated(false)
    setGovId('')
    setStatus(null)
    setRedirectUrl(null)

    fetch(`${proxyPath}/digital-id-mock/authentication/${token}/session`, {
      headers: { Accept: 'application/json' },
    })
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (!active) return
        if (data?.governmentId) {
          setGovId(data.governmentId)
        }
        if (data?.status) setStatus(data.status)
        if (data?.redirectUrl) setRedirectUrl(data.redirectUrl)
        setInitiated(true)
      })
      .catch(() => {
        if (active) setInitiated(true)
      })

    return () => {
      active = false
    }
  }, [token])

  const buildUrl = result => {
    let url = `${proxyPath}/digital-id-mock/authentication/doAuth?authSessionId=${encodeURIComponent(token)}&result=${result}`
    if (govId) url += `&govId=${encodeURIComponent(govId)}`
    return url
  }

  if (!initiated) return <p>Loading...</p>

  const isTerminal = TERMINAL_STATUSES.includes(status)

  return (
    <>
      <h1>Authentication</h1>
      {isTerminal ? (
        <p>The government ID of the authenticating person is</p>
      ) : (
        <p>Enter government ID of authenticating person</p>
      )}
      <div className={styles.lineWrapper}>
        <TextInput
          id="govId"
          label="Government ID"
          value={govId}
          disabled={isTerminal}
          onChange={(_, value) => setGovId(value)}
        />
      </div>
      {isTerminal ? (
        <>
          <div className={styles.infoSection}>
            <div className={styles.sectionLabel}>Session status</div>
            <div className={styles.listItem}>
              <span className={styles.badge}>{status}</span>
            </div>
          </div>
          {/* Nothing redirects on our behalf once the browser lands here instead of the mock's own
              page, so a finished session still needs a way back to the calling service. */}
          {redirectUrl && (
            <div className={styles.lineWrapper}>
              <Button
                id="continueButtonId"
                fullWidth
                onClick={() => {
                  window.location.href = redirectUrl
                }}
              >
                Continue
              </Button>
            </div>
          )}
        </>
      ) : (
        <>
          <div className={styles.lineWrapper}>
            <Button
              id="successButtonId"
              fullWidth
              onClick={() => {
                window.location.href = buildUrl('COMPLETE')
              }}
            >
              Authenticate
            </Button>
          </div>
          <div className={styles.lineWrapper}>
            <Button
              id="failureButtonId"
              type={ButtonType.Secondary}
              fullWidth
              onClick={() => {
                window.location.href = buildUrl('CANCEL')
              }}
            >
              Cancel
            </Button>
          </div>
        </>
      )}
      {isInternal && (
        <UseRealServiceButton
          apiPath={`${proxyPath}/digital_id_service/authentication/${token}/use_real_service`}
        />
      )}
    </>
  )
}
